<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="readonly ? '班组预览' : (form.id ? '编辑班组' : '新增班组')"
      width="1200px"
      top="5vh"
      @closed="resetForm"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-form-item label="产线" prop="lineCode">
        <el-input v-model="lineDisplayName" :disabled="readonly" placeholder="请选择产线" readonly>
          <el-button
              slot="append"
              icon="el-icon-search"
              :disabled="readonly"
              @click="$refs.productionLineSelect.open()"/>
        </el-input>
      </el-form-item>
      <el-form-item label="班组编码" prop="teamCode">
        <el-input v-model="form.teamCode" :disabled="readonly" placeholder="请填写班组编码"/>
      </el-form-item>
      <el-form-item label="班组名称" prop="teamName">
        <el-input v-model="form.teamName" placeholder="选择产线后自动带出" readonly/>
      </el-form-item>
      <el-form-item label="班组日历" prop="defaultCalendarId">
        <el-input v-model="defaultCalendarName" placeholder="请选择班组日历" readonly>
          <el-button slot="append" icon="el-icon-search" :disabled="readonly" @click="openCalendarDialog"/>
        </el-input>
      </el-form-item>
      <!-- 班组日历关联的班次模板展示（只读） -->
      <el-form-item v-if="form.defaultCalendarId" label="日历班次">
        <div style="width: 100%">
          <el-table
              v-loading="calendarShiftsLoading"
              :data="calendarShifts"
              border
              size="small"
              style="width: 100%"
          >
            <el-table-column prop="shiftName" label="班次名称" min-width="120"/>
            <el-table-column label="上班时间" align="center" width="100">
              <template slot-scope="{ row }">{{formatTime(row.workStart)}}</template>
            </el-table-column>
            <el-table-column label="下班时间" align="center" width="100">
              <template slot-scope="{ row }">{{formatTime(row.workEnd)}}</template>
            </el-table-column>
            <el-table-column label="休息时间" align="center" width="140">
              <template slot-scope="{ row }">{{formatRestTime(row.restStart, row.restEnd)}}</template>
            </el-table-column>
            <el-table-column label="有效工时(小时)" align="center" width="110">
              <template slot-scope="{ row }">{{row.effectWorkHour != null ? row.effectWorkHour : ""}}</template>
            </el-table-column>
            <el-table-column label="允许加班" align="center" width="80">
              <template slot-scope="{ row }">{{row.canOvertime === 1 ? "是" : "否"}}</template>
            </el-table-column>
            <el-table-column label="最大加班(小时)" align="center" width="110">
              <template slot-scope="{ row }">{{row.overtimeMaxHour != null ? row.overtimeMaxHour : ""}}</template>
            </el-table-column>
            <el-table-column label="周几" align="center" width="80">
              <template slot-scope="{ row }">{{formatWeekday(row.weekdayRule)}}</template>
            </el-table-column>
          </el-table>
          <div
              v-if="!calendarShiftsLoading && calendarShifts.length === 0"
              style="color: #999; text-align: center; padding: 10px 0;">
            该日历尚未绑定班次模板
          </div>
        </div>
      </el-form-item>
      <el-form-item label="班组负责人">
        <el-input v-model="leaderName" placeholder="请选择班组负责人" readonly>
          <el-button slot="append" icon="el-icon-search" :disabled="readonly" @click="$refs.leaderSelect.open()"/>
        </el-input>
      </el-form-item>
      <el-form-item label="班组状态">
        <el-select v-model="form.teamStatus" :disabled="readonly" placeholder="请选择状态" style="width:100%">
          <el-option label="启用" :value="1"/>
          <el-option label="停用" :value="0"/>
        </el-select>
      </el-form-item>
      <!--      <el-form-item label="生效日期">-->
      <!--        <el-date-picker v-model="form.effectStart" type="date" value-format="yyyy-MM-dd" placeholder="请选择生效日期" style="width:100%"/>-->
      <!--      </el-form-item>-->
      <!--      <el-form-item label="截止日期">-->
      <!--        <el-date-picker v-model="form.effectEnd" type="date" value-format="yyyy-MM-dd" placeholder="请选择截止日期" style="width:100%"/>-->
      <!--      </el-form-item>-->
      <el-form-item label="备注">
        <el-input v-model="form.remark" type="textarea" :rows="2" placeholder="请输入备注"/>
      </el-form-item>
    </el-form>

    <!-- 班组人员子表 -->
    <div class="fm-section-title">班组人员</div>
    <el-button
        v-if="!readonly"
        type="success"
        size="small"
        icon="el-icon-plus"
        @click="openEmpDialog()">
      新增人员
    </el-button>
    <el-table :data="empList.filter(e => !e._deleted)" border size="small" style="margin-top: 10px">
      <el-table-column prop="empNo" label="员工工号" align="center" width="120"/>
      <el-table-column prop="empName" label="员工姓名" width="120"/>
      <el-table-column label="岗位类型" align="center" width="120">
        <template slot-scope="{ row }">{{postTypeMap[row.postType] || row.postType}}</template>
      </el-table-column>
      <el-table-column label="员工类型" align="center" width="160">
        <template slot-scope="{ row }">{{empTypeMap[row.empType] || row.empType}}</template>
      </el-table-column>
      <el-table-column label="主班组" align="center" width="120">
        <template slot-scope="{ row }">{{row.mainTeamFlag === 1 ? "主班组" : "兼职/顶岗"}}</template>
      </el-table-column>
      <el-table-column v-if="!readonly" label="操作" width="120" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" size="small" @click="openEmpDialog(row)">编辑</el-button>
          <el-button type="text" size="small" class="del" @click="handleDeleteEmp(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 人员编辑弹窗 -->
    <el-dialog
        v-el-drag-dialog
        :visible.sync="empDialogVisible"
        :close-on-click-modal="false"
        :title="empEditIndex === undefined ? '新增人员' : '编辑人员'"
        width="500px"
        append-to-body
    >
      <el-form ref="empForm" :model="empFormData" :rules="empRules" label-width="110px">
        <el-form-item label="员工" prop="empId">
          <el-input v-model="empName" readonly placeholder="请选择员工">
            <el-button slot="append" icon="el-icon-search" @click="$refs.empSelect.open()"/>
          </el-input>
        </el-form-item>
        <el-form-item label="岗位类型" prop="postType">
          <el-select v-model="empFormData.postType" style="width:100%">
            <el-option label="普通操作工" :value="1"/>
            <el-option label="班组长" :value="2"/>
            <el-option label="顶岗人员" :value="3"/>
            <el-option label="质检员" :value="4"/>
          </el-select>
        </el-form-item>
        <el-form-item label="员工类型">
          <el-select v-model="empFormData.empType" style="width:100%">
            <el-option label="本班组固定正式员工" :value="1"/>
            <el-option label="内部借调支援人员" :value="2"/>
            <el-option label="外协临时支援借调人员" :value="3"/>
          </el-select>
        </el-form-item>
        <el-form-item label="主班组">
          <el-select v-model="empFormData.mainTeamFlag" style="width:100%">
            <el-option label="主班组" :value="1"/>
            <el-option label="兼职/顶岗班组" :value="0"/>
          </el-select>
        </el-form-item>
        <!--        <el-form-item label="借调起始日期">-->
        <!--          <el-date-picker-->
        <!--              v-model="empFormData.borrowStart"-->
        <!--              type="date"-->
        <!--              value-format="yyyy-MM-dd"-->
        <!--              placeholder="请选择借调起始日期"-->
        <!--              style="width:100%"/>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="借调结束日期">-->
        <!--          <el-date-picker-->
        <!--              v-model="empFormData.borrowEnd"-->
        <!--              type="date"-->
        <!--              value-format="yyyy-MM-dd"-->
        <!--              placeholder="请选择借调结束日期"-->
        <!--              style="width:100%"/>-->
        <!--        </el-form-item>-->
        <el-form-item label="备注">
          <el-input v-model="empFormData.remark" type="textarea" :rows="2"/>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="empDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSaveEmp">确定</el-button>
      </span>
    </el-dialog>

    <!-- 选择班组负责人 -->
    <employee-select ref="leaderSelect" @select="selectLeader"/>
    <!-- 选择班组人员 -->
    <employee-select ref="empSelect" @select="selectEmp"/>
    <!-- 选择产线 -->
    <production-line-select ref="productionLineSelect" @select="selectLine"/>

    <!-- 选择班组日历（复用 view-table 组件） -->
    <el-dialog
        v-el-drag-dialog
        :visible.sync="calendarDialogVisible"
        :close-on-click-modal="false"
        append-to-body
        title="选择班组日历"
        top="8vh"
        width="800px"
    >
      <view-table
          ref="calendarViewTable"
          :filter="calendarFilter"
          :columns-property="calendarColumnsProperty"
          module="basic"
          url="fm/calendarMain"
          :tool-bar-show="false"
          :table-action="false"
          :table-select="false"
          @reset="calendarResetHandle"
      >
        <template slot="adSearch">
          <el-form :inline="true" :model="calendarFilter">
            <el-form-item label="日历编码">
              <el-input v-model.trim="calendarFilter.calendarCode" placeholder="请输入日历编码" clearable/>
            </el-form-item>
            <el-form-item label="日历名称">
              <el-input v-model.trim="calendarFilter.calendarName" placeholder="请输入日历名称" clearable/>
            </el-form-item>
          </el-form>
        </template>
      </view-table>
      <div slot="footer">
        <el-button @click="calendarDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <div slot="footer">
      <el-button v-if="readonly" @click="dialogVisible = false">关闭</el-button>
      <template v-else>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="loading" @click="submitHandle">确定</el-button>
      </template>
    </div>
  </el-dialog>
</template>

<script>
  import ViewTable from "@/components/ViewTable";
  import EmployeeSelect from "@/views/information/Employee/EmployeeSelect";
  import ProductionLineSelect from "@/views/factoryManage/production-line/ProductionLineSelect";

  export default {
    name: "TeamEdit",
    components: {ViewTable, EmployeeSelect, ProductionLineSelect},
    data() {
      return {
        dialogVisible: false,
        loading: false,
        readonly: false,
        leaderName: "",
        defaultCalendarName: "",
        empName: "",
        empEditIndex: undefined,
        empDialogVisible: false,
        empList: [],
        postTypeMap: {1: "普通操作工", 2: "班组长", 3: "顶岗人员", 4: "质检员"},
        empTypeMap: {1: "固定正式员工", 2: "内部借调支援", 3: "外协临时支援"},
        lineDisplayName: "",
        form: {},
        empFormData: {},
        // 班组日历选择弹窗数据
        calendarDialogVisible: false,
        calendarFilter: {calendarCode: "", calendarName: "", calendarType: 5},
        // 班组日历关联的班次列表（只读展示）
        calendarShifts: [],
        calendarShiftsLoading: false,
        calendarColumnsProperty: [
          {
            title: "日历编码",
            key: "calendarCode",
            width: 140,
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {color: "#2d8cf0", cursor: "pointer", fontWeight: "bold"},
                  on: {
                    click: () => this.selectCalendarRow(params.row),
                  },
                },
                params.row.calendarCode,
              );
            },
          },
          {title: "日历名称", key: "calendarName", minWidth: 150},
        ],
        rules: {
          lineCode: [{required: true, message: "请选择产线", trigger: "change"}],
          teamName: [{required: true, message: "请选择产线以自动带出班组名称", trigger: "change"}],
          teamCode: [{required: true, message: "请填写班组编码", trigger: "change"}],
          defaultCalendarId: [{required: true, message: "请选择班组日历", trigger: "change"}],
        },
        empRules: {
          empId: [{required: true, message: "请选择员工", trigger: "change"}],
          postType: [{required: true, message: "请选择岗位类型", trigger: "change"}],
        },
      };
    },
    methods: {
      resetForm() {
        this.form = {};
        this.readonly = false;
        this.leaderName = "";
        this.defaultCalendarName = "";
        this.lineDisplayName = "";
        this.empName = "";
        this.empList = [];
        this.empEditIndex = undefined;
        this.calendarShifts = [];
        this.$refs.form && this.$refs.form.resetFields();
      },
      open(row, readonly) {
        this.readonly = !!readonly;
        this.dialogVisible = true;
        this.empList = [];
        this.empEditIndex = undefined;
        this.calendarShifts = [];
        if (row && row.id) {
          this.$http.get("basic", `mES_Teams/full/${row.id}`).then((resp) => {
            if (resp.success && resp.data) {
              this.form = {...resp.data};
              this.leaderName = resp.data.teamLeaderName || "";
              this.defaultCalendarName = resp.data.defaultCalendarName || "";
              this.lineDisplayName = resp.data.lineName || "";
              this.empList = (resp.data.teamEmps || []).map((e) => ({...e}));
              // 编辑回显后，加载该日历关联的班次列表
              if (this.form.defaultCalendarId) {
                this.loadCalendarShifts(this.form.defaultCalendarId);
              }
            }
          });
        } else {
          this.form = {
            teamCode: "",
            teamName: "",
            plantCode: "",
            workshopCode: "",
            lineId: null,
            lineCode: "",
            lineName: "",
            lineType: null,
            teamLeaderId: null,
            defaultCalendarId: null,
            standardPersonNum: null,
            teamStatus: 1,
            effectStart: "",
            effectEnd: "",
            remark: "",
          };
          this.leaderName = "";
          this.defaultCalendarName = "";
        }
      },
      selectLeader(row) {
        this.form.teamLeaderId = row.employeeID;
        this.leaderName = row.employeeName;
      },
      selectCalendar(row) {
        this.form.defaultCalendarId = row.id;
        this.defaultCalendarName = row.calendarName;
      },
      // ===== 班组日历选择弹窗（复用 view-table） =====
      openCalendarDialog() {
        this.calendarDialogVisible = true;
        this.$nextTick(() => {
          this.$refs.calendarViewTable && this.$refs.calendarViewTable.loadData(1);
        });
      },
      calendarResetHandle(filter) {
        this.calendarFilter = Object.assign(this.calendarFilter, filter);
      },
      selectCalendarRow(row) {
        this.form.defaultCalendarId = row.id;
        this.defaultCalendarName = row.calendarName;
        this.calendarDialogVisible = false;
        // 选中后加载该日历关联的班次列表
        this.loadCalendarShifts(row.id);
      },
      // ===== 日历关联班次展示 =====
      loadCalendarShifts(calendarId) {
        if (!calendarId) {
          this.calendarShifts = [];
          return;
        }
        this.calendarShiftsLoading = true;
        this.$http.get("basic", `fm/calendarMain/${calendarId}`).then((resp) => {
          if (resp.success && resp.data) {
            this.calendarShifts = (resp.data.shifts && Array.isArray(resp.data.shifts)) ? resp.data.shifts : [];
          } else {
            this.calendarShifts = [];
          }
          this.calendarShiftsLoading = false;
        }).catch(() => {
          this.calendarShifts = [];
          this.calendarShiftsLoading = false;
        });
      },
      formatTime(time) {
        return time ? time.substring(0, 5) : "";
      },
      formatRestTime(restStart, restEnd) {
        if (!restStart && !restEnd) return "";
        return `${this.formatTime(restStart)} ~ ${this.formatTime(restEnd)}`;
      },
      formatWeekday(rule) {
        if (rule === null || rule === undefined) return "";
        const map = {0: "全周", 1: "周一", 2: "周二", 3: "周三", 4: "周四", 5: "周五", 6: "周六", 7: "周日"};
        return map[rule] || "";
      },
      selectLine(row) {
        this.form.lineId = row.id;
        this.form.lineCode = row.lineCode;
        this.form.lineName = row.lineName;
        this.form.lineType = row.lineType != null ? row.lineType : null;
        this.lineDisplayName = row.lineName;
        // 选择产线后自动带出班组名称
        this.form.teamName = row.lineName || "";
      },
      // ===== 人员行管理 =====
      openEmpDialog(row) {
        this.empName = "";
        if (row) {
          this.empEditIndex = this.empList.indexOf(row);
          this.empFormData = {...row};
          this.empName = row.empName || "";
        } else {
          this.empEditIndex = undefined;
          this.empFormData = {
            empId: null,
            postType: 1,
            dutyStatus: 1,
            empType: 1,
            mainTeamFlag: 1,
            borrowStart: "",
            borrowEnd: "",
            remark: "",
          };
        }
        this.empDialogVisible = true;
      },
      selectEmp(row) {
        this.empFormData.empId = row.employeeID;
        this.empFormData.empNo = row.employeeNO;
        this.empFormData.empName = row.employeeName;
        this.empName = row.employeeName;
      },
      handleSaveEmp() {
        this.$refs.empForm.validate((valid) => {
          if (!valid) return;
          const item = {...this.empFormData};
          // 验重：同一班组内员工不允许重复（编辑时排除自身）
          const duplicated = this.empList.some((e) => {
            if (e._deleted) return false;
            if (this.empEditIndex !== undefined && this.empList.indexOf(e) === this.empEditIndex) return false;
            return e.empId === item.empId;
          });
          if (duplicated) {
            this.$message.warning("该员工已在此班组中，请勿重复添加");
            return;
          }
          if (this.empEditIndex !== undefined) {
            this.$set(this.empList, this.empEditIndex, {...this.empList[this.empEditIndex], ...item, _changed: true});
          } else {
            item._new = true;
            this.empList.push(item);
          }
          this.empDialogVisible = false;
        });
      },
      handleDeleteEmp(row) {
        const idx = this.empList.indexOf(row);
        if (idx !== -1) {
          if (row._new) {
            this.empList.splice(idx, 1);
          } else {
            this.$set(this.empList, idx, {...row, _deleted: true});
          }
        }
      },
      submitHandle() {
        this.$refs.form.validate((valid) => {
          if (!valid) return;
          const validEmps = this.empList.filter((e) => !e._deleted);
          if (validEmps.length === 0) {
            this.$message.warning("请至少添加一名班组人员");
            return;
          }
          this.loading = true;
          const payload = {
            ...this.form,
            teamEmps: validEmps.map((e) => {
              const item = {...e};
              delete item._new;
              delete item._changed;
              delete item._deleted;
              delete item.teamName;
              delete item.empNo;
              delete item.empName;
              return item;
            }),
          };
          this.$http.post("basic", "mES_Teams/saveFull", payload)
            .then((resp) => {
              if (resp.success) {
                this.$message.success(this.form.id ? "编辑成功" : "新增成功");
                this.dialogVisible = false;
                this.$emit("save-success");
              }
            })
            .finally(() => {
              this.loading = false;
            });
        });
      },
    },
  };
</script>

<style scoped>
.fm-section-title {
  font-weight: bold;
  padding: 10px 0 5px;
  margin-bottom: 10px;
  border-bottom: 1px solid #e8e8e8;
  color: #409eff;
}

.del {
  color: #f56c6c;
}
</style>
